module.exports = __webpack_public_path__ + "assets/c272d35c00f368eab9e034321388ac7d.mp3";